<template>
    <div>
        <h3 class="font-bold text-xl pb-3 pt-4">
            {{ $t('Parts') }}
        </h3>
        <figure v-if="diagram" class="mb-4 [&_svg]:fill-none">
            <PartsBySeriesDiagram :html="diagram.svg" v-model="selectedLegendKey" />
        </figure>

        <div v-if="diagram" class="flex items-center gap-2 mb-4">
            <SearchInput @input="emit('search', $event.target.value)" :placeholder="$t('Search')"/>
            <select v-if="finishes.length" v-model="selectedFinish" class="py-1 rounded-sm border-gray-tier-7">
                <option :value="null">Any Finish</option>
                <option v-for="option in finishes" :value="option">{{ option }}</option>
            </select>
            <select v-if="Object.keys(diagram?.legend).length" v-model="selectedLegendKey" class="py-1 rounded-sm border-gray-tier-7">
                <option :value="null">Any Part Type</option>
                <option v-for="(label, key) in diagram.legend" :value="key">{{ label }}</option>
            </select>
        </div>


        <LoadingSpinner v-if="isLoading"/>
        <TableNew
            v-else-if="parts.length"
            name="parts-table"
            :collapsable="true"
            :sort="sort"
            :rows="parts"
            :columns="columns"
            :row-component="TableRowThree"
            row-identifier="id"
        />
        <RecordsNotFound
            v-else
            header="We haven't listed parts here yet."
        />
    </div>
</template>
<script setup>
import { LoadingSpinner, RecordsNotFound, SearchInput, TableNew, TableProductImage, TableRowThree } from "@/Components";
import { ref, watch } from "vue";
import PartsBySeriesDiagram from "@/Components/Modules/Parts/PartsBySeriesDiagram.vue";

const emit = defineEmits(['search', 'sort', 'filter:finish'])

const props = defineProps({
    series: {
        type: Object,
        required: true,
    },
    parts: {
        type: Array,
        required: true,
        default: () => []
    },
    finishes: {
        type: Array,
        required: true,
        default: () => []
    },
    diagram: {
        type: Object,
        default: () => null
    },
    sort: {
        type: Object,
        default: () => {}
    },
    isLoading: {
        type: Boolean,
        default: false,
    },
})

const selectedFinish = ref(null)
const selectedLegendKey = ref(null)

watch(selectedFinish, (value) => emit('filter:finish', value))
watch(selectedLegendKey, (value) => emit('filter:legend', value))

const columns = [
    {
        name: 'SKU',
        component: TableProductImage,
        path: (row) => row,
        sortPath: 'item_id',
        props: ({ row }) => ({
            value: row,
            link: {
                name: 'web.catalog.products.show',
            },
            preview: true,
        }),
    },
    {
        name: 'Type',
        path: ({ row }) => {
            const key = row.legend_key
            const legend = props.diagram?.legend;
            const label = legend[key] ? legend[key] : key;

            return `<span class="text-sm whitespace-nowrap">${label}</span>`;
        },
    },
];
</script>
